<template>
    <div ref="recordview" class="record-page">
        <span id="example-neutral" class="theme-swatch theme-swatch--neutral" aria-hidden="true"></span>
        <span id="example-accent" class="theme-swatch theme-swatch--accent" aria-hidden="true"></span>

        <section class="record-hero">
            <div class="record-hero__copy">
                <p class="record-kicker">{{ $tt('播放记录') }}</p>
                <h1>{{ $tt('你的收听档案') }}</h1>
                <p class="record-hero__text">{{ week_record.jocker || $tt('最近播放记录') }}</p>
                <div role="tablist" class="period-tabs">
                    <button type="button" :class="{ 'is-active': selectPeriod === 'week' }" @click="handleSelectPeriod('week')">Last week</button>
                    <button type="button" :class="{ 'is-active': selectPeriod === 'month' }" @click="handleSelectPeriod('month')">Last month</button>
                    <button type="button" :class="{ 'is-active': selectPeriod === 'year' }" @click="handleSelectPeriod('year')">Last year</button>
                </div>
            </div>
            <div class="weekly-panel">
                <div class="weekly-panel__topline">
                    <span>{{ week_record.date_range || getPreviousPeriodLabel() }}</span>
                    <strong>{{ week_record.week_rate || 0 }}%</strong>
                </div>
                <div class="weekly-panel__body">
                    <div>
                        <span class="weekly-panel__label">{{ $tt('音乐播放') }}</span>
                        <strong class="weekly-panel__count">{{ week_record.this_week_total || 0 }}</strong>
                        <span class="weekly-panel__compare">{{ week_record.last_week_total || 0 }} vs {{ getPreviousPeriodLabel() }}</span>
                    </div>
                    <div class="record-disc" aria-hidden="true"><span></span></div>
                </div>
                <div id="weekly" class="weekly-chart"></div>
            </div>
        </section>

        <section class="best-section">
            <header class="section-heading">
                <h2>{{ $tt('最佳音乐') }}</h2>
                <p>{{ $tt('按播放行为汇总艺术家、专辑和单曲。') }}</p>
            </header>
            <div class="music-grid">
                <article v-for="section in musicSections" :key="section.key" class="music-card" :class="'music-card--' + section.tone">
                    <header class="music-card__header">
                        <div>
                            <span>{{ section.title }}</span>
                            <strong>{{ section.count || 0 }}</strong>
                        </div>
                        <em>{{ section.rate || '0%' }}</em>
                    </header>

                    <div v-if="section.records.length > 0" class="music-card__cover">
                        <img v-if="section.records[0][2]" :src="callCoverArtUrl(section.records[0][2])" :alt="section.records[0][0]">
                        <img v-else src="/static/dist/img/album_null.jpg" :alt="$tt('暂无封面')">
                        <div class="music-card__coverText">
                            <span>{{ section.bestLabel }}</span>
                            <strong>#1 {{ section.records[0][0] }}</strong>
                            <small>{{ $tt('record.countTimes', { count: section.records[0][1] }) }}</small>
                        </div>
                    </div>
                    <div v-else class="music-card__empty">{{ $tt('暂无歌曲') }}</div>

                    <ol class="music-rank">
                        <li v-for="(item, index) in section.records.slice(1, 5)" :key="section.key + index">
                            <span>#{{ index + 2 }} {{ item[0] }}</span>
                            <strong>{{ item[1] }}</strong>
                        </li>
                    </ol>

                    <footer class="music-card__new">
                        <div>
                            <span>{{ section.newLabel }}</span>
                            <strong>{{ section.newest[0] || '-' }}</strong>
                            <small>{{ $tt('record.countTimes', { count: section.newest[1] || 0 }) }}</small>
                        </div>
                        <img v-if="section.newest[2]" :src="callCoverArtUrl(section.newest[2])" :alt="section.newest[0]">
                        <img v-else src="/static/dist/img/album_null.jpg" :alt="$tt('暂无封面')">
                    </footer>
                </article>
            </div>
        </section>

        <section class="chart-section">
            <header class="section-heading">
                <h2>{{ $tt('榜单') }}</h2>
                <p>{{ $tt('从风格、年代、平台和时间段查看收听倾向。') }}</p>
            </header>
            <div class="chart-grid">
                <article v-for="panel in chartPanels" :key="panel.id" class="chart-card" :class="'chart-card--' + panel.size">
                    <h3>{{ panel.title }}</h3>
                    <div :id="panel.id" class="chart-canvas"></div>
                </article>
            </div>
        </section>

        <section class="fact-section">
            <article v-for="fact in quickFacts" :key="fact.key" class="fact-card">
                <div class="fact-card__top">
                    <span>{{ fact.label }}</span>
                    <em>{{ fact.rate }}</em>
                </div>
                <strong>{{ fact.value }}</strong>
                <small>vs {{ fact.previous }}</small>
            </article>
        </section>
    </div>
</template>

<script>
import {getCoverArtUrl} from '@/api/apiUrl/subsonic/serializers'

export default {
    name: "record",
    data() {
        return {
            currentTheme: localStorage.getItem('theme') || 'light',
            selectPeriod: 'week',
            week_record: {
                record: [["product", "上周", "本周"]],
                this_week_total: 0,
                last_week_total: 0,
                week_rate: 0,
                jocker: '',
                date_range: ''
            },
            prefectMusic: {'track':{'newest':[]},'album':{'newest':[]},'artist':{'newest':[]}},
            hotGenres: {},
            hotDecades: {},
            platformStats: {},
            listeningStats: {
                'duration': {
                    'total_seconds': 1620,
                    'formatted': this.$tt('record.hours', { count: 0 }),
                    'last_week': this.$tt('record.hours', { count: 0 }),
                    'growth_rate': "0%"
                },
                'average': {
                    'count': 1,
                    'last_week': 0,
                    'growth_rate': "0%"
                },
                'most_active': {
                    'count': 9,
                    'date': "Jan 10",
                    'last_week': 0,
                    'growth_rate': "0%"
                }
            }
        }
    },
    computed: {
        musicSections() {
            const artist = this.prefectMusic.artist || {newest: []}
            const album = this.prefectMusic.album || {newest: []}
            const track = this.prefectMusic.track || {newest: []}
            return [
                {
                    key: 'artist',
                    tone: 'neutral',
                    title: this.$tt('艺术家'),
                    count: artist.count,
                    rate: artist.rate,
                    records: this.prefectMusic.artist_record || [],
                    newest: artist.newest || [],
                    bestLabel: this.$tt('最佳艺术家'),
                    newLabel: this.$tt('最佳新艺术家')
                },
                {
                    key: 'album',
                    tone: 'base',
                    title: this.$tt('专辑'),
                    count: album.count,
                    rate: album.rate,
                    records: this.prefectMusic.album_record || [],
                    newest: album.newest || [],
                    bestLabel: this.$tt('最佳专辑'),
                    newLabel: this.$tt('最佳新专辑')
                },
                {
                    key: 'track',
                    tone: 'accent',
                    title: this.$tt('单曲'),
                    count: track.count,
                    rate: track.rate,
                    records: this.prefectMusic.track_record || [],
                    newest: track.newest || [],
                    bestLabel: this.$tt('最佳单曲'),
                    newLabel: this.$tt('最佳新单曲')
                }
            ]
        },
        chartPanels() {
            return [
                {id: 'hot-tag', title: this.$tt('最热风格'), size: 'wide'},
                {id: 'year', title: this.$tt('音乐年代'), size: 'regular'},
                {id: 'plat', title: this.$tt('平台分布'), size: 'regular'},
                {id: 'listen', title: this.$tt('收听时钟'), size: 'wide'}
            ]
        },
        quickFacts() {
            return [
                {
                    key: 'duration',
                    label: this.$tt('收听时间'),
                    value: this.listeningStats.duration.formatted,
                    rate: this.listeningStats.duration.growth_rate,
                    previous: this.listeningStats.duration.last_week
                },
                {
                    key: 'average',
                    label: this.$tt('平均记录'),
                    value: this.listeningStats.average.count,
                    rate: this.listeningStats.average.growth_rate,
                    previous: this.listeningStats.average.last_week
                },
                {
                    key: 'most_active',
                    label: this.$tt('最活跃一天'),
                    value: `${this.listeningStats.most_active.count} ${this.listeningStats.most_active.date}`,
                    rate: this.listeningStats.most_active.growth_rate,
                    previous: this.listeningStats.most_active.last_week
                }
            ]
        }
    },
    methods: {
        callCoverArtUrl(coverArt) {
            return getCoverArtUrl({coverArt})
        },
        getPreviousPeriodLabel() {
            if (this.selectPeriod === 'week') {
                return this.$tt('record.period.lastWeek')
            }
            if (this.selectPeriod === 'month') {
                return this.$tt('record.period.lastMonth')
            }
            return this.$tt('record.period.lastYear')
        },
        oklchToHex(oklchString) {
            const culori = require('culori');

            const parsedColor = culori.parse(oklchString);
            if (parsedColor) {
                return culori.formatHex(parsedColor);
            }

            const match = oklchString.match(/oklch\(([\d.]+)\s+([\d.]+)\s+([\d.]+)\)/);
            if (!match) {
                return oklchString;
            }

            const [, l, c, h] = match.map(Number);

            // 使用culori将OKLCH转换为RGB
            const rgb = culori.converter('rgb')({mode: 'oklch', l, c, h});

            // 将RGB值限制在0-1范围内，然后转换为0-255范围的整数
            const clamp = (value) => Math.max(0, Math.min(1, value));
            const r = Math.round(clamp(rgb.r) * 255);
            const g = Math.round(clamp(rgb.g) * 255);
            const b = Math.round(clamp(rgb.b) * 255);

            // 将RGB转换为16进制
            const toHex = (value) => {
                const hex = value.toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            };

            return '#' + toHex(r) + toHex(g) + toHex(b);
        },
        draw() {
            const weeklyEl = document.getElementById('weekly')
            const chartSource = this.week_record && Array.isArray(this.week_record.record)
                ? this.week_record.record
                : [["product", "上周", "本周"]]
            if (!weeklyEl) {
                return
            }

            // 从元素的计算样式中获取颜色
            let accentColor = window.getComputedStyle(document.getElementById('example-accent'))['backgroundColor']
            accentColor = this.oklchToHex(accentColor)
            let neutralColor = window.getComputedStyle(document.getElementById('example-neutral'))['backgroundColor']
            neutralColor = this.oklchToHex(neutralColor)
            
            // 先销毁旧的图表实例
            const weeklyChart = this.$echarts.getInstanceByDom(weeklyEl)
            if (weeklyChart) {
                weeklyChart.dispose()
            }
            
            // 创建新的图表实例
            const myChart = this.$echarts.init(weeklyEl)
            const option = {
                legend: {},
                color: [neutralColor, accentColor],
                tooltip: {},
                dataset: {
                    source: chartSource
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: false
                    }
                },
                yAxis: [{
                    type: "value",
                    show: false
                }],
                series: [
                    {
                        type: 'bar',
                        barMaxWidth: 34,
                        barGap: '22%'
                    },
                    {
                        type: 'bar',
                        barMaxWidth: 34
                    }
                ]
            };
            myChart.setOption(option)
        },
        drawHotTag() {
            // 先销毁旧的图表实例
            const hotTagChart = this.$echarts.getInstanceByDom(document.getElementById('hot-tag'))
            if (hotTagChart) {
                hotTagChart.dispose()
            }
            
            const myChart = this.$echarts.init(document.getElementById('hot-tag'))
            const option = {
                color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: this.hotGenres.genres
                },
                toolbox: {
                    feature: {
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%', 
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: this.hotGenres.date_list
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: this.hotGenres.genres.map((genre, index) => ({
                    name: genre,
                    type: 'line',
                    stack: 'Total',
                    smooth: true,
                    lineStyle: {
                        width: 0
                    },
                    showSymbol: false,
                    areaStyle: {
                        opacity: 0.8,
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'][index]
                            },
                            {
                                offset: 1,
                                color: ['#00DDFF', '#37A2FF', '#FF0087', '#FFBF00', '#80FFA5'][index]
                            }
                        ])
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.hotGenres.daily_genres.map(day => day[index])
                }))
            };
            myChart.setOption(option)
        },
        drawYear() {
            // 先销毁旧的图表实例
            const yearChart = this.$echarts.getInstanceByDom(document.getElementById('year'))
            if (yearChart) {
                yearChart.dispose()
            }
            
            let accentColor = window.getComputedStyle(document.getElementById('example-accent'))['backgroundColor']
            accentColor = this.oklchToHex(accentColor)
            const myChart = this.$echarts.init(document.getElementById('year'))
            const option = {
                title: {
                    text: ''
                },
                color: [accentColor],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    show: true
                },
                yAxis: {
                    type: 'category',
                    data: this.hotDecades.decades
                },
                series: [
                    {
                        name: '',
                        type: 'bar',
                        data: this.hotDecades.daily_decades
                    }
                ]
            };
            myChart.setOption(option)
        },
        drawPlat() {
            // 先销毁旧的图表实例
            const platChart = this.$echarts.getInstanceByDom(document.getElementById('plat'))
            if (platChart) {
                platChart.dispose()
            }
            
            const myChart = this.$echarts.init(document.getElementById('plat'))
            const option = {
                legend: {
                    top: 'bottom'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c} ({d}%)'
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: {show: true}
                    }
                },
                series: [
                    {
                        name: this.$tt('平台分布'),
                        type: 'pie',
                        radius: [40, 100],
                        center: ['50%', '50%'],
                        roseType: 'area',
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.platformStats
                    }
                ]
            };
            myChart.setOption(option)
        },
        drawListen() {
            // 先销毁旧的图表实例
            const listenChart = this.$echarts.getInstanceByDom(document.getElementById('listen'))
            if (listenChart) {
                listenChart.dispose()
            }
            
            const myChart = this.$echarts.init(document.getElementById('listen'))
            const hours = [
                '00:00', '01:00', '02:00', '03:00', '04:00', '05:00',
                '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
                '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
                '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
            ];
            const data = this.listeningClock.listening_count
            const option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: (params) => {
                        return params[0].name + '<br/>' +
                            this.$tt('record.listenCount', { count: params[0].value })
                    }
                },
                xAxis: {
                    type: 'category',
                    data: hours,
                    axisLabel: {
                        interval: 3
                    }
                },
                yAxis: {
                    type: 'value',
                    show: false
                },
                series: [{
                    data: data,
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8
                    },
                    lineStyle: {
                        width: 0
                    },
                    itemStyle: {
                        opacity: 0
                    }
                }]
            };
            myChart.setOption(option)
        },
        fetchWeekRecord() {
            this.$api.Task.WeekRecord({period: this.selectPeriod}).then((res) => {
                if (!res || res.result === false || !res.data || !Array.isArray(res.data.record)) {
                    console.error('WeekRecord 接口返回异常:', res)
                    return
                }
                this.week_record = res.data
                this.draw()
            }).catch((err) => {
                console.error('WeekRecord 接口请求失败:', err)
            })
        },
        fetchPerfectMusic() {
            this.$api.Task.getPerfectMusic({period: this.selectPeriod}).then((res) => {
                this.prefectMusic = res.data
            })
        },
        fetchHotGenres() {
            this.$api.Task.getHotGenres({period: this.selectPeriod}).then((res) => {
                this.hotGenres = res.data
                this.drawHotTag()
            })
        },
        fetchHotDecades() {
            this.$api.Task.getHotDecades({period: this.selectPeriod}).then((res) => {
                this.hotDecades = res.data
                this.drawYear()
            })
        },
        fetchPlatformStats() {
            this.$api.Task.getPlatformStats({period: this.selectPeriod}).then((res) => {
                this.platformStats = res.data
                this.drawPlat()
            })
        },
        fetchListeningStats() {
            this.$api.Task.getListeningStats({period: this.selectPeriod}).then((res) => {
                this.listeningStats = res.data
            })
        },
        fetchListeningClock() {
            this.$api.Task.getListeningClock({period: this.selectPeriod}).then((res) => {
                this.listeningClock = res.data
                this.drawListen()
            })
        },
        handleSelectPeriod(period) {
            this.selectPeriod = period
            this.fetchWeekRecord()
            this.fetchPerfectMusic()
            this.fetchHotGenres()
            this.fetchHotDecades()
            this.fetchPlatformStats()
            this.fetchListeningStats()
            this.fetchListeningClock()
        }
    },
    mounted() {
        this.fetchWeekRecord()
        this.fetchPerfectMusic()
        this.fetchHotGenres()
        this.fetchHotDecades()
        this.fetchPlatformStats()
        this.fetchListeningStats()
        this.fetchListeningClock()
    },
    created() {
    }
}
</script>

<style lang="postcss" scoped>
.record-page {
    min-height: calc(100dvh - 4rem);
    padding: 1rem;
    color: oklch(var(--bc));
    background:
        radial-gradient(circle at 8% 0%, oklch(var(--p) / 0.14), transparent 26rem),
        radial-gradient(circle at 96% 8%, oklch(var(--a) / 0.12), transparent 24rem),
        linear-gradient(135deg, oklch(var(--b1)), oklch(var(--b2)));
}

.theme-swatch {
    position: fixed;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
}

.theme-swatch--neutral {
    background: oklch(var(--n));
}

.theme-swatch--accent {
    background: oklch(var(--a));
}

.record-hero,
.music-card,
.chart-card,
.fact-card {
    border: 1px solid oklch(var(--bc) / 0.08);
    border-radius: 1.5rem;
    background: linear-gradient(135deg, oklch(var(--b1) / 0.94), oklch(var(--b2) / 0.72)), oklch(var(--b1));
    box-shadow: inset 0 1px 0 oklch(var(--b1) / 0.76), 0 20px 48px oklch(var(--bc) / 0.09);
}

.record-hero {
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(24rem, 1.1fr);
    gap: 1rem;
    max-width: 78rem;
    min-height: 24rem;
    margin: 0 auto;
    padding: 1.35rem;
    overflow: hidden;
}

.record-hero__copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    padding: 0.35rem 0.35rem 0.35rem 0.55rem;
}

.record-kicker {
    margin: 0 0 0.55rem;
    color: oklch(var(--p));
    font-size: 0.82rem;
    font-weight: 850;
}

.record-hero h1 {
    max-width: 8ch;
    margin: 0;
    color: oklch(var(--bc));
    font-size: clamp(2.55rem, 5vw, 5.2rem);
    line-height: 0.96;
    font-weight: 880;
    letter-spacing: -0.04em;
}

.record-hero__text {
    max-width: 34rem;
    margin: 1rem 0 0;
    color: oklch(var(--bc) / 0.62);
    font-size: 1rem;
    line-height: 1.7;
}

.period-tabs {
    display: inline-grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.35rem;
    align-self: flex-start;
    max-width: 24rem;
    margin-top: 1.4rem;
    border-radius: 999px;
    padding: 0.36rem;
    background: oklch(var(--bc) / 0.07);
}

.period-tabs button {
    min-width: 0;
    border: 0;
    border-radius: 999px;
    padding: 0.62rem 0.8rem;
    color: oklch(var(--bc) / 0.62);
    background: transparent;
    font-size: 0.86rem;
    font-weight: 850;
    white-space: nowrap;
    cursor: pointer;
    transition: transform 0.18s ease, background-color 0.18s ease, color 0.18s ease;
}

.period-tabs button:hover {
    color: oklch(var(--bc));
}

.period-tabs button:active,
.music-card:active {
    transform: translateY(1px);
}

.period-tabs button.is-active {
    color: oklch(var(--pc));
    background: oklch(var(--p));
}

.weekly-panel {
    display: grid;
    grid-template-rows: auto minmax(8rem, 0.82fr) 13rem;
    gap: 0.75rem;
    border-radius: 1.25rem;
    padding: 1.15rem;
    color: oklch(var(--pc));
    background:
        radial-gradient(circle at 18% 0%, oklch(var(--p) / 0.48), transparent 14rem),
        radial-gradient(circle at 96% 24%, oklch(var(--a) / 0.35), transparent 13rem),
        linear-gradient(145deg, oklch(var(--bc) / 0.92), oklch(var(--bc) / 0.66));
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16), 0 24px 58px oklch(var(--bc) / 0.16);
}

.weekly-panel__topline,
.weekly-panel__body,
.music-card__header,
.music-card__new,
.fact-card__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.weekly-panel__topline span {
    min-width: 0;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.68);
    font-size: 0.86rem;
    font-weight: 780;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.weekly-panel__topline strong,
.weekly-panel__compare {
    border-radius: 999px;
    padding: 0.34rem 0.68rem;
    color: rgba(255, 255, 255, 0.88);
    background: rgba(255, 255, 255, 0.13);
    font-size: 0.82rem;
    font-weight: 900;
    white-space: nowrap;
}

.weekly-panel__body {
    align-items: flex-end;
}

.weekly-panel__label,
.weekly-panel__compare {
    display: inline-flex;
}

.weekly-panel__label {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.9rem;
    font-weight: 820;
}

.weekly-panel__count {
    display: block;
    margin-top: 0.24rem;
    color: rgba(255, 255, 255, 0.96);
    font-size: clamp(4rem, 8vw, 7.4rem);
    line-height: 0.9;
    font-weight: 880;
    letter-spacing: -0.06em;
}

.record-disc {
    flex: 0 0 min(14rem, 36%);
    aspect-ratio: 1;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background:
        radial-gradient(circle, rgba(255, 255, 255, 0.94) 0 10%, rgba(255, 255, 255, 0.23) 11% 13%, transparent 14% 18%, rgba(255, 255, 255, 0.17) 19% 20%, transparent 21%),
        conic-gradient(from 135deg, oklch(var(--p) / 0.96), oklch(var(--a) / 0.82), rgba(255, 255, 255, 0.18), oklch(var(--p) / 0.96));
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2), 0 24px 52px oklch(var(--p) / 0.22);
}

.record-disc span {
    width: 24%;
    aspect-ratio: 1;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.12);
}

.weekly-chart {
    width: 100%;
    min-height: 13rem;
}

.best-section,
.chart-section,
.fact-section {
    max-width: 78rem;
    margin: 1rem auto 0;
}

.section-heading {
    display: grid;
    gap: 0.35rem;
    margin: 1.35rem 0 0.8rem;
}

.section-heading h2 {
    margin: 0;
    color: oklch(var(--bc));
    font-size: clamp(1.45rem, 2.5vw, 2.15rem);
    line-height: 1.1;
    font-weight: 880;
    letter-spacing: -0.03em;
}

.section-heading p {
    max-width: 42rem;
    margin: 0;
    color: oklch(var(--bc) / 0.58);
    font-size: 0.95rem;
    line-height: 1.6;
}

.music-grid {
    display: grid;
    grid-template-columns: 1.1fr 0.9fr 1fr;
    gap: 0.9rem;
}

.music-card {
    min-width: 0;
    overflow: hidden;
    transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.music-card:hover {
    transform: translateY(-2px);
    border-color: oklch(var(--p) / 0.24);
    box-shadow: 0 22px 50px oklch(var(--bc) / 0.12);
}

.music-card__header {
    padding: 1rem 1rem 0.85rem;
}

.music-card__header div {
    display: grid;
    gap: 0.2rem;
}

.music-card__header span,
.music-card__new span,
.fact-card__top span {
    color: oklch(var(--bc) / 0.56);
    font-size: 0.82rem;
    font-weight: 800;
}

.music-card__header strong {
    color: oklch(var(--bc));
    font-size: 2.45rem;
    line-height: 0.95;
    font-weight: 880;
    letter-spacing: -0.04em;
}

.music-card__header em,
.fact-card__top em {
    flex: 0 0 auto;
    border-radius: 999px;
    padding: 0.32rem 0.58rem;
    color: oklch(var(--p));
    background: oklch(var(--p) / 0.1);
    font-size: 0.76rem;
    font-style: normal;
    font-weight: 900;
}

.music-card__cover {
    position: relative;
    min-height: 18rem;
    overflow: hidden;
    background: oklch(var(--bc) / 0.08);
}

.music-card__cover img {
    width: 100%;
    height: 19rem;
    object-fit: cover;
    filter: saturate(0.9) contrast(0.92);
}

.music-card__cover::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, transparent 36%, rgba(0, 0, 0, 0.72));
    pointer-events: none;
}

.music-card__coverText {
    position: absolute;
    inset-inline: 1rem;
    bottom: 0.95rem;
    z-index: 1;
    display: grid;
    gap: 0.22rem;
    color: rgba(255, 255, 255, 0.94);
}

.music-card__coverText span {
    color: rgba(255, 255, 255, 0.68);
    font-size: 0.78rem;
    font-weight: 850;
}

.music-card__coverText strong {
    min-width: 0;
    overflow: hidden;
    font-size: 1.16rem;
    line-height: 1.22;
    font-weight: 850;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.music-card__coverText small {
    color: rgba(255, 255, 255, 0.72);
}

.music-card__empty {
    display: grid;
    place-items: center;
    min-height: 18rem;
    color: oklch(var(--bc) / 0.54);
    background: oklch(var(--bc) / 0.06);
}

.music-rank {
    display: grid;
    gap: 0.35rem;
    margin: 0;
    padding: 0.75rem;
    list-style: none;
}

.music-rank li {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.8rem;
    align-items: center;
    border-radius: 1rem;
    padding: 0.66rem 0.75rem;
    background: oklch(var(--b1) / 0.58);
}

.music-rank span {
    min-width: 0;
    overflow: hidden;
    color: oklch(var(--bc));
    font-size: 0.88rem;
    font-weight: 760;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.music-rank strong {
    color: oklch(var(--bc) / 0.58);
    font-size: 0.86rem;
    font-weight: 850;
}

.music-card__new {
    margin: 0 0.75rem 0.75rem;
    border-radius: 1.15rem;
    padding: 0.75rem;
    background: oklch(var(--p) / 0.08);
}

.music-card--accent .music-card__new,
.music-card--accent .music-card__header em {
    color: oklch(var(--a));
    background: oklch(var(--a) / 0.11);
}

.music-card__new div {
    min-width: 0;
    display: grid;
    gap: 0.14rem;
}

.music-card__new strong {
    min-width: 0;
    overflow: hidden;
    color: oklch(var(--bc));
    font-size: 0.96rem;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.music-card__new small {
    color: oklch(var(--bc) / 0.54);
    font-size: 0.78rem;
}

.music-card__new img {
    flex: 0 0 4rem;
    width: 4rem;
    height: 4rem;
    border-radius: 1rem;
    object-fit: cover;
}

.chart-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.9rem;
}

.chart-card {
    min-width: 0;
    padding: 1rem;
}

.chart-card--wide {
    min-height: 22rem;
}

.chart-card h3 {
    margin: 0 0 0.55rem;
    color: oklch(var(--bc));
    font-size: 1.05rem;
    font-weight: 850;
}

.chart-canvas {
    width: 100%;
    height: 19rem;
}

.fact-section {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.9rem;
    padding-bottom: 1.2rem;
}

.fact-card {
    min-width: 0;
    padding: 1rem;
}

.fact-card strong {
    display: block;
    min-width: 0;
    overflow: hidden;
    margin-top: 1.5rem;
    color: oklch(var(--bc));
    font-size: clamp(1.8rem, 3vw, 2.8rem);
    line-height: 1;
    font-weight: 880;
    letter-spacing: -0.04em;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fact-card small {
    display: block;
    margin-top: 0.7rem;
    color: oklch(var(--bc) / 0.52);
    font-size: 0.86rem;
}

@media (prefers-reduced-motion: reduce) {
    .period-tabs button,
    .music-card {
        transition: none;
    }
}

@media (max-width: 1023px) {
    .record-hero {
        grid-template-columns: 1fr;
    }

    .music-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 767px) {
    .record-page {
        min-height: auto;
        padding: 0.75rem 0.65rem 1rem;
    }

    .record-hero {
        min-height: auto;
        border-radius: 1.35rem;
        padding: 1rem;
    }

    .record-hero__copy {
        padding: 0;
    }

    .record-hero h1 {
        max-width: 9ch;
        font-size: 2.65rem;
    }

    .record-hero__text {
        font-size: 0.95rem;
    }

    .period-tabs {
        width: 100%;
        max-width: none;
    }

    .period-tabs button {
        padding: 0.58rem 0.42rem;
        font-size: 0.78rem;
    }

    .weekly-panel {
        grid-template-rows: auto auto 11rem;
        border-radius: 1.2rem;
        padding: 1rem;
    }

    .weekly-panel__body {
        align-items: flex-start;
    }

    .weekly-panel__count {
        font-size: 4.2rem;
    }

    .record-disc {
        flex-basis: 7.6rem;
    }

    .section-heading {
        margin-top: 1.1rem;
    }

    .music-card,
    .chart-card,
    .fact-card {
        border-radius: 1.25rem;
    }

    .music-card__cover,
    .music-card__empty {
        min-height: 16rem;
    }

    .music-card__cover img {
        height: 16rem;
    }

    .chart-grid,
    .fact-section {
        grid-template-columns: 1fr;
    }

    .chart-canvas {
        height: 18rem;
    }

    .weekly-chart {
        min-height: 11rem;
    }
}
</style>
